import { Dialog } from '@headlessui/react'
import { useSnapshot } from 'valtio'
import { type ReactElement } from 'react'
import { recurringPaymentProxy } from '../../../../../shared/proxies/recurringPaymentProxy'
import Label from '../../../../../shared/components/ui/forms/Label'
import { executeRecurringTransactionPause } from './executeRecurringTransactionPause'

export function ConfirmPauseModal (): ReactElement | null {
  const { displayPauseModal, recurringPayment } = useSnapshot(recurringPaymentProxy)

  if (recurringPayment == null) {
    return null
  }

  return (
    <Dialog
      open={displayPauseModal}
      onClose={() => { recurringPaymentProxy.displayPauseModal = false }}
      className="fixed z-10 inset-0 overflow-y-auto"
    >
      <div className="flex items-center justify-center min-h-screen">
        <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />

        <div className="relative bg-white rounded max-w-2xl mx-auto p-5">
          <Dialog.Title>
            <div className="mb-4">
              <div className="text-2xl font-medium text-center">Pause Recurring Charge</div>

            </div>
          </Dialog.Title>
          <Label additionalClasses="text-center text-gray-700 text-lg" text="Are you sure you want to pause this recurring charge?" />

          <div className="mt-6 flex flex-row justify-center">
            <button
              className="rounded bg-wpy-blue-700 border-blue-700 px-4 mx-4 py-2 text-white hover:bg-blue-300"
              onClick={async () => { await executeRecurringTransactionPause(recurringPayment.id.toString()) }}
            >
              Pause Charge
            </button>

            <button
              className="rounded bg-wpy-alert-red-600 border-red-700 px-4 mx-4 py-2 text-white hover:bg-red-300"
              onClick={() => { recurringPaymentProxy.displayPauseModal = false }}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>

    </Dialog>
  )
}
